import type { NoiseFunction3D } from "simplex-noise";
import type { GameConfig } from "../config/GameConfig";

export class LowerOcean {
  constructor(
    private readonly config: GameConfig,
    private readonly noise: NoiseFunction3D,
  ) {}

  sample(x: number, y: number, time: number): { x: number; y: number } {
    const o = this.config.ocean;
    const t = time * o.noiseSpeed;
    const nx = this.noise(x * o.noiseScale, y * o.noiseScale, t + 20);
    const ny = this.noise(x * o.noiseScale + 17, y * o.noiseScale + 9, t + 3);
    const lift = this.noise(x * o.noiseScale * 0.35, t * 0.4, 4);
    return {
      x: nx * o.strength * o.turbulence * o.lateralBias,
      y: ny * o.strength * 0.45 - (0.55 + lift * 0.45) * o.fromBottom,
    };
  }
}
